/**
 * CONFIGURACIÓN GLOBAL DE PANACHE
 * Centraliza IDs de Fudo, capacidades y endpoints.
 */
import { CAPACIDADES } from './shared/constants.js';

export const CONFIG = {
    /**
     * Feature flags. Cambiar a true cuando la feature esté lista para producción.
     * ADMIN_ENABLED: habilita el panel de staff gateado en /admin.
     */
    FEATURES: {
        ADMIN_ENABLED: true
    },

    API: {
        FUDO: '/api/fudo',
        FUDO_GP: '/api/fudo-gp',
        RESERVAS: '/api/reservas',
        KIOSCO: '/api/kiosco',
        LIQUIDACION: '/api/liquidacion',
        // S4/S5a (AD8): escritor único de adelantos/pagos —
        // adelanto_crear/anular (S4) y pago_registrar/anular (S5a) en el
        // MISMO endpoint.
        PAYROLL_MOVIMIENTOS: '/api/payroll-movimientos',
        TIMEOUT_MS: 8000
    },
    
    FUDO: {
        CATEGORIES: {
            BRUNCH: [147, 131, 117, 138, 137, 133, 132, 130],
            // SALSAS(150) va justo debajo de PASTAS(126) y GUARNICIONES(149)
            // debajo de MILANESAS(120). En Fudo son SUBcategorías (parentCategory
            // 126/120), pero la GP API las entrega como una categoría más. Su
            // `position` de Fudo es ~4.8M (caerían al final de la carta), por eso
            // se ubican manualmente acá, en el orden de sección deseado.
            LUNCH: [140, 146, 123, 126, 150, 120, 149, 128, 121, 122, 124, 142, 141],
            BAR: [101, 73, 74, 90, 94, 92, 89, 96, 85, 125, 91]
        },
        EXCLUDED_CATEGORIES: ["NO MOSTRAR", "Otros", "COMBOS"]
    },

    RESERVAS: {
        CAPACIDADES, // imported from js/shared/constants.js
    },

    /**
     * Único número de WhatsApp del local. Lo usan eventos y reservas; el botón
     * flotante y el pie de `index.html` son HTML estático y lo repiten a mano,
     * así que si cambia acá hay que cambiarlo también allá.
     * Formato internacional sin + ni espacios (+54 9 3572 699923). El 9 es
     * obligatorio: identifica al número como celular argentino.
     */
    WHATSAPP: '5493572699923',

    SECCIONES_CARTA: [
        {
            id: 'brunch',
            name: 'DESAYUNO MERIENDA & BRUNCH',
            icon: 'fa-mug-saucer',
            get categoryIds() { return CONFIG.FUDO.CATEGORIES.BRUNCH; }
        },
        {
            id: 'lunch',
            name: 'ALMUERZO & CENA',
            icon: 'fa-utensils',
            get categoryIds() { return CONFIG.FUDO.CATEGORIES.LUNCH; }
        },
        {
            id: 'bar',
            name: 'BEBIDAS',
            icon: 'fa-wine-glass',
            get categoryIds() { return CONFIG.FUDO.CATEGORIES.BAR; }
        }
    ]
};
